import type { TMessages } from '@/types/TMessages'

export const messages = {
  leasing: {
    field: {
      agreement: {
        label:
          'Ввод номера телефона подтверждает ваше согласие с <LinkToAgreement>политикой обработки персональных данных</LinkToAgreement>',
      },
    },
  },
  tinkoffLoan: {
    field: {
      agreement: {
        text: 'Я даю согласие Банку на обработку всех моих персональных данных, указанных в заявке, любыми способами, в том числе третьими лицами, в том числе воспроизведение, электронное копирование, обезличивание, блокирование, уничтожение, а также вышеуказанную обработку иных моих персональных данных, полученных в результате их обработки, с целью:<ul class="list-with-marks space-holder8"><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>заключения с Банком универсального договора</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>выпуска, обслуживания банковских карт</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>создания информационных систем персональных данных Банка</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>страхования моей жизни/ здоровья/ имущества и иного страхования, осуществляемого при содействии Банка или в пользу Банка и/или в связи с заключением договора</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>а также в любых других целях, прямо или косвенно связанных с выпуском и обслуживанием банковских карт и предложением иных продуктов Банка, и направления мне информации о новых продуктах и услугах Банка и/или его контрагентов.</li></ul> <p class="space-holder8">Я даю согласие контрагентам Банка на обработку всех моих персональных данных, имеющихся в распоряжении/доступе Банка и/или контрагентов Банка, в том числе с целью информирования меня об услугах контрагентов, а также на обработку сведений об абонентах и оказываемым им услугам связи (в случае если контрагентом Банка является оператор связи) с целью проведения оценки вероятности моей платежеспособности в будущем для принятия решения о выпуске кредитной карты.</p> <p class="space-holder8">Указанное согласие дано на срок 15 лет, а в случае его отзыва обработка моих персональных данных должна быть прекращена Банком и/или третьими лицами и данные уничтожены при условии расторжения Договора и полного погашения задолженности по Договору в срок не позднее 1 (одного) года с даты прекращения действия Договора.</p> <p class="space-holder8">Я даю согласие на предоставление Банком всей имеющейся обо мне информацию в объеме, в порядке и на условиях, определенных Федеральным законом «О кредитных историях» № 218-ФЗ от 30 декабря 2004 года, во все бюро кредитных историй, включенные в государственный реестр бюро кредитных историй, а также на получение кредитного отчета из вышеозначенных бюро для заключения Договора и в течение срока действия Договора.</p> <p class="space-holder8" />Я даю согласие на получение мной рекламы, рассылки, в том числе по сети подвижной радиотелефонной связи, от Банка, его контрагентов и аффилированных лиц.',
      },
    },
  },
  creditOfferModal: {
    label: {
      loanAmount: 'Сумма кредита',
      fullName: 'ФИО контактного лица',
      organizationInn: 'ИНН организации',
      email: 'E-mail',
      phone: 'Номер телефона',
      city: 'Город обслуживания',
      comment: 'Комментарий, цели финансирования',
      agreement:
        'Я соглашаюсь с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в Банк ВТБ (ПАО)',
    },
    title: 'Подать заявку на кредит',
    description: 'Подайте заявку и с вами свяжется наш финансовый менеджер и проконсультирует по всем вопросам',
    submitButton: 'Отправить',
    submit: 'Отправить',
    error: 'Не удалось отправить заявку на кредит',
  },
  individualOffer: {
    title: 'Заявка на индивидуальные условия от ВТБ',
    error: 'Не удалось отправить заявку',
  },
  leasingOffer: {
    label: {
      fullName: 'Ваше имя',
      email: 'E-mail',
      organizationInn: 'ИНН или наименование организации*',
      organizationName: 'Наименование организации',
      comment: 'Комментарии',
      location: 'Местонахождение',
      agreement: {
        interleasingLeasing:
          'Я соглашаюсь с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в ООО "Интерлизинг"',
        sberLeasing:
          'Я соглашаюсь с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в АО "Сберблизинг"',
        stoneXii:
          'Я соглашаюсь с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в ООО "СТОУН-XXI"',
        vtbLeasing:
          'Я соглашаюсь с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в ВТБ Лизинг (акционерное общество)',
        baltiyskiyLeasing:
          'Я соглашаюсь с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в ООО "Балтийский лизинг"',
        alfaLeasing: {
          text: 'Я соглашаюсь ',
          link: 'с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail) и ИНН в ОOО "Альфамобиль"',
        },
      },
    },
    title: 'Заявка на лизинг',
    submitButton: 'Отправить',
    error: 'Не удалось отправить заявку на лизинг',
  },
  common: {
    forms: {
      required: 'Необходимо заполнить',
      incorrectRegionsForFinancingProduct: 'Данный регион недоступен для кредитования. Выберите другой регион или другой кредитный продукт',
      incorrectValue: 'Некорректная сумма',
    },
  },
  advancePaymentOffer: {
    field: {
      agreement: {
        label:
          'Нажатие на кнопку "Отправить" подтверждает ваше <LinkToAgreement>согласие на передачу данных</LinkToAgreement>, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в ООО "Деметра Трейдинг"',
      },
    },
    label: {
      fullName: 'ФИО контактного лица',
      contactPersonPosition: 'Должность контакта',
      phone: 'Введите ваш телефон',
      email: 'E-mail',
      organizationInn: 'ИНН организации',
      organizationName: 'Наименование организации',
      loanAmount: 'Желаемая сумма, руб',
      cropsArea: 'Площадь посевов, га',
      comment: 'Ваши условия поставки товара',
      tinkoff: {
        text: 'Я соглашаюсь ',
        link: 'с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail), ИНН и названия организации в АО «Тинькофф Банк»',
      },
      desiredAdvancePaymentDate: 'Дата предоставления аванса',
      grossHarvest: 'Валовый сбор, тыс. т (план)',
    },
    title: 'Заявка на авансирование',
    error: 'Не удалось отправить заявку на авансирование',
    minAmountErrorMessage: 'Минимальная сумма составляет 1 млн рублей. Измените желаемую сумму, чтобы отправить заявку.',
    button: {
      submit: 'Отправить',
    },
  },
  creditOffer: {
    label: {
      alfaBank: {
        text: 'Я соглашаюсь ',
        link: 'с передачей данных, внесенных в форму заявки, а также моих персональных данных (фамилия, имя, отчество, e-mail), ИНН и названия организации в АО «Альфа-Банк»',
      },
    },
  },

  agent: {
    label: {
      fullName: 'Введите ваше имя',
      phone: 'Введите ваш телефон',
    },
  },
  tinkoffOffer: {
    label: {
      fullName: 'Ваше имя',
      phone: 'Номер телефона',
      organizationInn: 'ИНН',
      organizationName: 'Название организации',
      loanAmount: 'Сумма кредита',
    },
  },
  form: {
    placeholder: {
      nearestCity: 'Ближайший населённый пункт',
      comment: 'Комментарий, цели финансирования',
    },
  },
  expressCreditAlfaBank: {
    label: {
      comment: 'Цели кредита',
      loanAmount: 'Сумма кредита',
    },
    modal: {
      title: 'Условия передачи информации',
      text: 'Я даю согласие Банку на обработку всех моих персональных данных, указанных в заявке, любыми способами, в том числе третьими лицами, в том числе воспроизведение, электронное копирование, обезличивание, блокирование, уничтожение, а также вышеуказанную обработку иных моих персональных данных, полученных в результате их обработки, с целью:<ul class="list-with-marks space-holder8"><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>заключения с Банком универсального договора;</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>выпуска, обслуживания банковских карт;</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>создания информационных систем персональных данных Банка;</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>страхования моей жизни/ здоровья/ имущества и иного страхования, осуществляемого при содействии Банка или в пользу Банка и/или в связи с заключением договора;</li><li class="policy-inner-modal-item"><span class="policy-inner-modal-space"></span>а также в любых других целях, прямо или косвенно связанных с выпуском и обслуживанием банковских карт и предложением иных продуктов Банка, и направления мне информации о новых продуктах и услугах Банка и/или его контрагентов.</li></ul> <p class="space-holder8">Я даю согласие контрагентам Банка на обработку всех моих персональных данных, имеющихся в распоряжении/доступе Банка и/или контрагентов Банка, в том числе с целью информирования меня об услугах контрагентов, а также на обработку сведений об абонентах и оказываемым им услугам связи (в случае если контрагентом Банка является оператор связи) с целью проведения оценки вероятности моей платежеспособности в будущем для принятия решения о выпуске кредитной карты.</p> <p class="space-holder8">Указанное согласие дано на срок 15 лет, а в случае его отзыва обработка моих персональных данных должна быть прекращена Банком и/или третьими лицами и данные уничтожены при условии расторжения Договора и полного погашения задолженности по Договору в срок не позднее 1 (одного) года с даты прекращения действия Договора.</p> <p class="space-holder8">Я даю согласие на предоставление Банком всей имеющейся обо мне информацию в объеме, в порядке и на условиях, определенных Федеральным законом «О кредитных историях» № 218-ФЗ от 30 декабря 2004 года, во все бюро кредитных историй, включенные в государственный реестр бюро кредитных историй, а также на получение кредитного отчета из вышеозначенных бюро для заключения Договора и в течение срока действия Договора.</p> <p class="space-holder8" />Я даю согласие на получение мной рекламы, рассылки, в том числе по сети подвижной радиотелефонной связи, от Банка, его контрагентов и аффилированных лиц.',
    },
    error: {
      incorrectMaxLoanValue: 'Максимальная сумма кредита – 10 млн руб',
    },
  },
  loanMFO: {
    label: {
      loanAmount: 'Желаемая сумма, руб.',
      phone: 'Введите ваш телефон',
    },
  },
  centerInvestLoan: {
    field: {
      loanTerm: {
        label: 'Срок кредита',
        suffix: 'мес.',
        humanReadableValue: '{numberOfMonths} мес.',
      },
      loanAmount: {
        label: 'Сумма кредита',
      },
      agreement: {
        label:
          'Нажатие на кнопку "Отправить" подтверждает ваше <LinkToAgreement>согласие на передачу данных</LinkToAgreement>, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в ПАО КБ "Центр-инвест"',
      },
    },
  },
  expressMFO: {
    field: {
      agreement: {
        label:
          'Нажатие на кнопку "Отправить" подтверждает ваше согласие на передачу данных, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в <LinkToAgreement>ООО МКК "Поле Инвест"</LinkToAgreement>',
      },
    },
    error: {
      incorrectMaxLoanValue: 'Максимальная сумма кредита – 200 млн руб',
    },
    submitButton: 'Отправить',
  },
  revolvingLoanSber: {
    field: {
      agreement: {
        label:
          'Нажатие на кнопку "Отправить" подтверждает ваше <LinkToAgreement>согласие на передачу данных</LinkToAgreement>, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в ПАО «Сбербанк России»',
      },
    },
  },
  sberInvestmentLoan: {
    field: {
      agreement: {
        label:
          'Нажатие на кнопку "Отправить" подтверждает ваше <LinkToAgreement>согласие на передачу данных</LinkToAgreement>, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в ПАО «Сбербанк России»',
      },
    },
  },
  lombardLoanAlfaBank: {
    error: {
      incorrectMaxLoanValue: 'Максимальная сумма кредита – 50 млн руб',
    },
  },
  incorrectMinValue: 'Некорректная сумма',
  poleCredit: {
    error: {
      incorrectMaxLoanValue: 'Максимальная сумма кредита – 200 млн руб',
    },
  },
} satisfies TMessages
